export const getIdentifierFieldNameByParamValue = (
  value: string,
  useExternalId: boolean = false
): string => {
  return value?.length === 8 ? 'id' : (useExternalId ? 'externalId' : 'parcelId');
};
